import { ConditionBase } from '../condition.type';

export interface ConditionOneOf extends ConditionBase {
  /**
   * The value of the related field must be included in this
   * array for the condition to be fulfilled.
   */
  readonly one_of: readonly any[];
}

/**
 * Type guard that checks if an object fulfills the `ConditionOneOf` interface
 *
 * @param c Non nullish object
 * @returns `true` if `c` satisfies `ConditionOneOf`
 */
export const isConditionOneOf = (c: Record<string, any>): c is ConditionOneOf =>
  'one_of' in c && Array.isArray(c['one_of']);

/**
 * @param condition Condition object
 *
 * @returns
 * Condition function that returns `true` if the value is
 * included in the given array of values, otherwise `false`.
 *
 * @example
 * oneOf({one_of: [1, 2]})(1) // true
 * oneOf({one_of: [1, 2]})(0) // false
 */
export function oneOf(condition: ConditionOneOf): (value: unknown) => boolean {
  const { one_of } = condition;

  return (value) => one_of.includes(value);
}
